/* ScrubNotes — page behaviour, delegated from document so it works regardless
   of which sections the merchant keeps, reorders or removes.

   Add-to-cart is deliberately NOT handled here. Every CTA is a real
   <form method="post" action="/cart/add">, which works without JavaScript and
   cannot desync from whatever cart implementation the theme uses. */
(function () {
  if (window.__scrubnotesInit) return;
  window.__scrubnotesInit = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ── Sample-page tabs ─────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-sn-tab]');
    if (!tab) return;
    var root = tab.closest('[data-sn-pages]');
    if (!root) return;

    var i = Number(tab.getAttribute('data-sn-tab'));
    root.querySelectorAll('[data-sn-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', String(Number(t.getAttribute('data-sn-tab')) === i));
    });
    root.querySelectorAll('[data-sn-frame]').forEach(function (f) {
      f.classList.toggle('is-active', Number(f.getAttribute('data-sn-frame')) === i);
    });
    var cap = root.querySelector('[data-sn-caption]');
    if (cap) {
      var page = tab.getAttribute('data-sn-page') || '';
      cap.textContent = page ? 'Page ' + page + ' · click to enlarge' : 'Click to enlarge';
    }
  });

  /* ── Lightbox ─────────────────────────────────────────────────────── */
  function closeLightbox() {
    document.querySelectorAll('[data-sn-lightbox].is-open').forEach(function (lb) {
      lb.classList.remove('is-open');
    });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sn-viewer]');
    if (opener) {
      var root = opener.closest('[data-sn-pages]');
      var lb = root && root.querySelector('[data-sn-lightbox]');
      if (!lb) return;
      var active = root.querySelector('[data-sn-frame].is-active');
      var idx = active ? active.getAttribute('data-sn-frame') : '0';
      lb.querySelectorAll('[data-sn-lb-frame]').forEach(function (f) {
        f.classList.toggle('is-active', f.getAttribute('data-sn-lb-frame') === idx);
      });
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest('[data-sn-lightbox]')) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  /* ── Contents disclosure ──────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sn-toc-toggle]');
    if (!t) return;
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
    var label = t.querySelector('[data-sn-toc-label]');
    if (label) {
      var n = t.getAttribute('data-sn-count') || '';
      label.textContent = (open ? 'Show ' : 'Hide ') + n + ' systems';
    }
  });

  /* ── Sticky buy bar ───────────────────────────────────────────────── */
  ready(function () {
    var bar = document.querySelector('[data-sn-bar]');
    if (!bar) return;

    var anchor = document.querySelector('[data-sn-hero]') || document.querySelector('.sn-hero');

    if (!anchor || !('IntersectionObserver' in window)) {
      var threshold = Number(bar.getAttribute('data-sn-after')) || 620;
      var onScroll = function () {
        bar.classList.toggle('is-visible', window.scrollY > threshold);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }

    new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -40% 0px' }
    ).observe(anchor);
  });
})();